export default "__VITE_PUBLIC_ASSET__c45d5d7b__"